import FormBuilderConfig from "../../../../../toolkit/baseForms2/formBuilder/FormBuilder.config";
import IButtonBuilder from "../../../../../toolkit/baseForms2/iButtonBuilder/IButtonBuilder";
import ITextBuilder from "../../../../../toolkit/baseForms2/iTextBuilder/ITextBuilder";
import IUserSelectorBuilder from "../../../../../toolkit/baseForms2Commons/iUserSelectorBuilder/IUserSelectorBuilder";

export type Inputs =
  | "idUser"
  | "consolidado"
  | "totalVentas"
  | "numeroProspectos";
export type Buttons = "aceptar" | "cancelar";

export const formConfig: FormBuilderConfig<Inputs, Buttons> = {
  inputs: [
    {
      name: "idUser",
      label: "* Asesor",
      bts: { mCol: 12 },
      component: IUserSelectorBuilder
    },
    {
      name: "consolidado",
      label: "* Compromiso (Puntos de Alcance)",
      bts: { mCol: 12 },
      component: ITextBuilder
    },
    {
      name: "totalVentas",
      label: "* Compromiso (Ingresos)",
      bts: { mCol: 12 },
      component: ITextBuilder
    },
    {
      name: "numeroProspectos",
      label: "* Compromiso (Prospectos)",
      bts: { mCol: 12 },
      component: ITextBuilder
    }
  ],
  buttons: [
    {
      name: "aceptar",
      label: "Agregar",
      isSubmit: true,
      component: IButtonBuilder,
      bts: { mCol: 6 },
      props: {
        color: "success"
      }
    },
    {
      name: "cancelar",
      label: "Cancelar",
      component: IButtonBuilder,
      bts: { mCol: 6 },
      props: {
        color: "secondary"
      }
    }
  ],
  validations: {
    idUser: {
      required: {
        validator: value => !value,
        message: () => "El asesor es requerido"
      }
    },
    consolidado: {
      required: {
        validator: value => !value && value !== 0,
        message: () => "El compromiso de puntos de alcance es requerido"
      },
      minNumber: {
        validator: value => value && Number(value) < 0,
        message: () => "Debe ser mayor o igual a 0"
      }
    },
    totalVentas: {
      required: {
        validator: value => !value && value !== 0,
        message: () => "El compromiso de ingresos es requerido"
      },
      minNumber: {
        validator: value => value && Number(value) < 0,
        message: () => "Debe ser mayor o igual a 0"
      }
    },
    numeroProspectos: {
      required: {
        validator: value => !value && value !== 0,
        message: () => "El compromiso de prospectos es requerido"
      },
      minNumber: {
        validator: value => value && Number(value) < 0,
        message: () => "Debe ser mayor o igual a 0"
      }
    }
  },
  rows: [
    ["idUser"],
    ["consolidado"],
    ["totalVentas"],
    ["numeroProspectos"],
    ["aceptar", "cancelar"]
  ]
};
